import { Fragment, useContext, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { DropdownItem } from "reactstrap";

import { Spinner } from "../../../AbstractElements";
import ActionOptions from "../../Common/Component/ActionOptions";
import CustomizerContext from "../../../_helper/Customizer";
import ServiceCityDeleteModal from "../Modals/ServiceCityDeleteModal";

import { serviceCityColumns } from "../../../Data/Configuration/ServiceCity";
import SharedDataContext from "../../../_helper/SharedData";

const ServiceCityTable = ({ isRefresh, loader,setRowsPerPage,
  rowsPerPage, setLoader,serviceCityData,fetchData,paginationTotalRows,
  trgiggerRefresh,onChangePage,onChangeRowsPerPage}) => {
  

  const { mix_background_layout } = useContext(CustomizerContext);
  // const { allCityData } = useContext(SharedDataContext);

  const conditionalRowStyles = [
    {
      when: (row) => row["Deleted"],
      style: (row) => ({ backgroundColor: row["Deleted"] ? "#F9B5A6" : "" }),
    },
  ];

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteObj, setDeleteObj] = useState({});  
  const [pagination, setPagination] = useState(0);
 

  const toggleDeleteModal = () => setDeleteModal(!deleteModal);

  const processData = serviceCityData.map((element) => {
    return {
      name: element.name ? element.name : "-",
      cityCode: element.cityCode ? element.cityCode : "-",
      aggregatorName: element.aggregatorCompanyName
        ? element.aggregatorCompanyName
        : "-",
      companyName: element.companyName ? element.companyName : "-",
      placeOfSupply: element.placeOfSupply ? element.placeOfSupply : "-",
      Deleted: element.isDeleted,
      action: (
        <ActionOptions key={element.id}>
          <Fragment>
            <DropdownItem
              className="border-0"
              key={"row-edit"}
              onClick={() => {
                setDeleteObj(element);
                toggleDeleteModal();
              }}
            >
              {element.isDeleted ? (
                <i className="fa fa-recycle" />
              ) : (
                <i className="fa fa-trash-o" />
              )}{" "}
              {element.isDeleted ? "Recover" : "Delete"}
            </DropdownItem>
          </Fragment>
        </ActionOptions>
      ),
    };
  });

  return (
    <Fragment>
      <div className="table-responsive corporate-client-table">
        <DataTable
          columns={serviceCityColumns}
          data={processData}
          center={true}
          fixedHeader
          fixedHeaderScrollHeight={"57vh"}
          pagination
          paginationPerPage={rowsPerPage}
          paginationTotalRows={paginationTotalRows}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
          conditionalRowStyles={conditionalRowStyles}
          paginationServer
          progressPending={loader}
          progressComponent={
            <div className="loader-box" style={{ height: "57vh" }}>
              <Spinner
                attrSpinner={{
                  className: "loader-3",
                  style: {
                    width: "30px",
                    height: "30px",
                    borderColor: "#39B54A",
                    borderBottomColor: "transparent",
                  },
                }}
              />
            </div>
          }
          theme={mix_background_layout == "dark-only" ? "dark" : "default"}
        />
      </div>

      <ServiceCityDeleteModal
        LargeModaltoggle={toggleDeleteModal}
        Large={deleteModal}
        deleteObj={deleteObj}
        fetchData={fetchData}
      />
    </Fragment>
  );
};

export default ServiceCityTable;
